import { useState } from 'react';
import RecordEntry from '../Modules/Records/RecordsEntry';

let setModalData = null;
let onRecordRefresh = null;

export const RecordEntryModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [prefilledData, setPrefilledData] = useState({});

  setModalData = (data, refreshCallback = null) => {
    if (data) {
      setPrefilledData(data);
      onRecordRefresh = refreshCallback;
      setIsOpen(true);
    } else {
      setIsOpen(false);
      setPrefilledData({});
      onRecordRefresh = null;
    }
  };

  const handleRecordAdded = (deletionData) => {
    setIsOpen(false);
    setPrefilledData({});
    if (onRecordRefresh && typeof onRecordRefresh === 'function') {
      onRecordRefresh(deletionData);
    }
    onRecordRefresh = null;
  };

  if (!isOpen) return null;

  return (
    <RecordEntry
      triggerButton={false}
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open);
        if (!open) {
          setPrefilledData({});
          onRecordRefresh = null;
        }
      }}
      prefilledData={prefilledData}
      onRecordAdded={handleRecordAdded}
    />
  );
};

export const openRecordEntryModal = (recordData, refreshCallback = null) => {
  if (setModalData) {
    setModalData(recordData, refreshCallback);
  }
};

export const closeRecordEntryModal = () => {
  if (setModalData) {
    setModalData(null);
  }
};
